import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import moment from 'moment-timezone'

//import DayPicker from 'react-day-picker';
// Or import the input component
import DayPickerInput from 'react-day-picker/DayPickerInput';

import 'react-day-picker/lib/style.css';

import styles from './index.css'



@withRouter
export default class FortnightPickerField extends React.Component {
  
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.any
  }

  static defaultProps = {
    onChange: value => {},
  }

  state = {
  }

  constructor(props) {
    super(props)
    this.dateToFortnight = this.dateToFortnight.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  dateToFortnight(date) {
    const base = moment(new Date(2018, 3, 4))
                  .subtract(14*100, 'days')
                  .startOf('week').add(3, 'days')
    const md = moment(date)
    let spw = null
    const diff = Math.abs(md.diff(base, 'days'))
    spw = md.subtract(diff % 14, 'days')

    return {
      from: spw.toDate(),
      to  : spw.add(13, 'days').toDate() 
    }
  }

  componentDidMount() {
    const { from, to } = this.dateToFortnight(this.props.value)
    this.setState({ from, to })
    if (from !== this.props.value) {
      this.onChange(from)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      const { from, to } = this.dateToFortnight(nextProps.value)
      this.setState({ from, to })
    }
  }

  onChange(value) {
    const { from, to } = this.dateToFortnight(value)
    this.setState({ from, to })
    this.props.onChange(from)
  }

  render() {
    let fortnight = undefined
    if (this.state.from) {
      const { from, to } = this.state 
      fortnight = { from, to }
    } 
    const modifiersStyles = {
      selected: { 
        color: 'white',
        backgroundColor: '#51cf66',
        borderRadius: '0'
      },
      fortnight: {
        color: 'white',
        backgroundColor: '#51cf66',
        borderRadius: '0'
      },
    };
    return (
      <div className={styles.CalendarField}>
        <DayPickerInput 
          hideOnDayClick={false}
          value={this.state.from}
          dayPickerProps={{ 
            modifiers: { fortnight }, 
            modifiersStyles,
            fixedWeeks: true 
          }}
          onDayChange={this.onChange}
          //calendarClassName={styles.Calendar} 
          />
        <div className={styles.Icon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="#000" fillRule="evenodd" d="M17.347 2.478h-2.478l-.001-1.239a1.239 1.239 0 1 0-2.479 0v1.24l-4.955-.001V1.239a1.239 1.239 0 1 0-2.478 0v1.24l-2.478-.001A2.479 2.479 0 0 0 0 4.956v12.39a2.479 2.479 0 0 0 2.478 2.477h14.868a2.479 2.479 0 0 0 2.477-2.477l.001-12.39c0-1.37-1.11-2.478-2.478-2.478zm0 14.869H2.477V6.814h14.869v10.533z"/>
          </svg>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/FortnightPickerField/index.jsx